import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumLabel',
  standalone: true,
})
export class EnumLabelPipe implements PipeTransform {
  transform(value: string | number, enumType: any): string {
    if (!value || !enumType) return '';

    return enumType[value] ?? value;
  }
}
